import React from 'lib/react';

import { EVGrid, EVSkeleton, makeStyles } from 'lib/components';

const useStyles = makeStyles((theme) => ({
  fieldContainer: {
    marginBottom: theme.spacing(1),
    '@media (max-width: 340px)': {
      flex: 1,
    },
  },
  loaderContainer: {
    display: 'inline-flex',
  },
  heading: {
    borderRadius: '6px',
    '@media (max-width: 640px)': {
      minHeight: '81px',
    },
  },
  textField: {
    minHeight: '20px',
    borderRadius: '6px',
  },
  imageField: {
    minHeight: '200px',
    borderRadius: '6px',
  },
  inputField: {
    minHeight: '28px',
    borderRadius: '6px',
  },
}));

export default function CompanyLogoLoader() {
  const classes = useStyles();
  return (
    <EVGrid container className={classes.loaderContainer} item direction="column">
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.textField} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.imageField} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.inputField} animation="wave" variant="rect" />
      </EVGrid>
    </EVGrid>
  );
}
